import type { ReactElement } from 'react'
import { GLYPHS } from './glyphs'

interface UnitGlyphProps {
  unit: { glyph: string }
  size?: number
}

export function UnitGlyph({ unit, size = 80 }: UnitGlyphProps): ReactElement {
  const Glyph = GLYPHS[unit.glyph]
  if (!Glyph) {
    console.warn(`UnitGlyph: unknown glyph key "${unit.glyph}", falling back to crane`)
    const Fallback = GLYPHS.crane!
    return <Fallback size={size} />
  }
  return <Glyph size={size} />
}
